export default __webpack_public_path__ + "static/SharpGrotesk-Medium-fdd9681db3af4dfa889d935002961df7.otf";